import { observer } from "mobx-react-lite";
import React from "react";

import Button from "components/commons/Button/Button";
import Modal from "components/commons/Modal/Modal";

import AppStore from "stores/AppStore";

import "./ErrorModal.scss";

const ErrorModal: React.FC = () => {
    const {
        isErrorModalVisible,
        setIsErrorModalVisible,
        clearErrorModalMessage,
        errorModalMessage,
        i18n: {
            commons: { done, error }
        }
    } = AppStore;

    const ModalHeader = () => (
        <div className="c-error-modal__header">
            <h2>{error}</h2>
            <Button
                className="c-error-modal__done-button"
                text={done}
                onClick={async () => {
                    setIsErrorModalVisible(false);
                    clearErrorModalMessage();
                }}
            />
        </div>
    );

    return (
        <div className="c-error-modal">
            <Modal
                isModalVisible={isErrorModalVisible}
                disableFooter
                customHeader={<ModalHeader />}
                onClose={() => {
                    setIsErrorModalVisible(false);
                }}
            >
                <div className="c-error-modal__content">
                    {errorModalMessage}
                </div>
            </Modal>
        </div>
    );
};

export default observer(ErrorModal);
